
<template>
    <router-view></router-view>
</template>

<script lang="ts">
    import { Options, Vue } from "vue-class-component";

    @Options({
        name: "ElasticIndex",
        components: {},
    })
    export default class ElasticIndex extends Vue {}
</script>
